var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list.length > 0)?_c('div',[_c('IntervalIOListWeb',{staticClass:"hidden-sm-and-down",attrs:{"list":_vm.list}}),_c('IntervalIOListMob',{staticClass:"hidden-md-and-up",attrs:{"list":_vm.list}})],1):_c('div',[_c('empty-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }